type HtmlProps = {
  content: string | TrustedHTML;
  className?: string;
};

export default function HtmlContent({ content, className = '' }: HtmlProps) {
  return (
    <article
      className={`prose ${className}`}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}
